import { render, staticRenderFns } from "./InquiriesPrev.vue?vue&type=template&id=47841328&"
import script from "./InquiriesPrev.vue?vue&type=script&lang=ts&"
export * from "./InquiriesPrev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports